import { create } from 'zustand'

import { TRoomId } from '@/entities/room/@x/map'

type ViewedRoomAction = {
  addViewedRoom: (roomId: TRoomId) => void
}

type ViewedRoomState = {
  viewedRooms: TRoomId[]
  hasViewed: (roomId: TRoomId) => boolean
  actions: ViewedRoomAction
}

export const useViewedRoomStore = create<ViewedRoomState>((set, get) => ({
  viewedRooms: [],
  hasViewed: (roomId: TRoomId) => {
    const { viewedRooms } = get()

    return viewedRooms.includes(roomId)
  },
  actions: {
    addViewedRoom: roomId => {
      set(state => ({
        viewedRooms: [...state.viewedRooms.filter(id => id !== roomId), roomId],
      }))
    },
  },
}))
